import {storageAvailable} from '../base/utils';

class Cookies {
    constructor() {
        this.$cookies = document.getElementById('cookies');
        this.$cookiesSave = this.$cookies.querySelector('.js-accept-cookies');
        this.config = {
            name: 'cookies',
            hiddenClass: 'cookies-hidden'
        };

        if (!this.$cookies)
            return;

        if (storageAvailable('localStorage')) {
            this.handleStorageCookie();
        } else {
            this.handleCookieCookie();
        }

        this.init();
    }

    init() {
        let acceptsCookies = this.check();

        if (!acceptsCookies) {
            this.$cookies.classList.remove(this.config.hiddenClass);

            this.$cookiesSave.addEventListener('click', e => {
                e.preventDefault();

                this.save();
                this.$cookies.classList.add(this.config.hiddenClass);
            });
        }
    }

    handleStorageCookie() {
        this.check = () => window.localStorage.getItem(this.config.name);
        this.save = () => window.localStorage.setItem(this.config.name, '1');
    }

    handleCookieCookie() {
        this.check = () => Cookies.getCookie(this.config.name);
        this.save = () => Cookies.setCookie(this.config.name, '1');
    }

    static setCookie(name, value, days) {
        let expires = '';

        if (days) {
            let date = new Date();

            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    static getCookie(name) {
        let nameEQ = name + '=',
            ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];

            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}

export default Cookies;
